import { render, staticRenderFns } from "./AdditionColleagues.vue?vue&type=template&id=6915dbc9"
import script from "./AdditionColleagues.vue?vue&type=script&lang=js"
export * from "./AdditionColleagues.vue?vue&type=script&lang=js"
import style0 from "./AdditionColleagues.vue?vue&type=style&index=0&id=6915dbc9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports